<script>
import Layout from '@layouts/main'
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <Layout class="centered-container">
    <div class="inner">
      <h1 :class="$style.title">
        404
        <template v-if="resource">{{ resource }}</template>
        Not Found
      </h1>
      <el-button v-if="loggedIn" @click="$router.push({ name: currentUser.redirect })">回到預設頁</el-button>
      <el-button v-else @click="$router.push({ name: 'login' })">回到登入頁</el-button>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
